import React, { FC, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './breadcrumbs.module.scss';


const Breadcrumbs: FC = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // 路經中翻英
  const pathTranslations: { [key: string]: string } = {
    'about-us': '關於大創',
    'trading': '多元化交易',
    'faq': 'Q&A',
    'know-how': '如何購電',
    'public-information': '公開資訊',
  };


  return (
    <nav className={`${styles["breadcrumbs_container"]} container`}>
      <div className="row">
        <div className='breadcrumbs_ul'>
          <li className='breadcrumbs_li'>
            <Link to="/">首頁</Link>
          </li>
          {pathnames.length > 0 && <div className='line'>|</div>}
          {pathnames.map((value, index) => {
            const to = `/${pathnames.slice(0, index + 1).join('/')}`;
            const translatedValue = pathTranslations[value] || value;
            return (
              <li key={to} className='breadcrumbs_li'>
                <Link to={to}>{translatedValue}</Link>
                {index < pathnames.length - 1 && <div className='line'>|</div>}
              </li>
            );
          })}
        </div>
      </div>

    </nav>
  );
};

export default Breadcrumbs;
